
          import "Favorites_1dksmc3.linaria.css";
          import React from "react";
import { styled } from "@linaria/react";
import ButtonBase from "./Base";
import { HeartCheckedIcon, HeartUncheckedIcon } from "../icons";
const Button = /*#__PURE__*/styled(ButtonBase)({
  name: "Button",
  class: "b17m0lpn"
});

const Favorites = ({
  checked,
  ...rest
}) => /* @__PURE__ */React.createElement(Button, { ...rest
}, checked ? /* @__PURE__ */React.createElement(HeartCheckedIcon, null) : /* @__PURE__ */React.createElement(HeartUncheckedIcon, null));

export default Favorites;
          